import Component from '@glimmer/component'
import { starImages } from 'teacher-ui-client/components/tables/fluency-sprints/star-assets'
import { t } from 'ember-intl'
import { gt, or } from 'ember-truth-helpers'

interface Args {
  showNotPassed: boolean
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export class StarLegend extends Component<Signature> {
  readonly starItems = [
    { src: starImages[0], width: 21, height: 21 },
    { src: starImages[1], width: 21, height: 21 },
    { src: starImages[2], width: 31, height: 21 },
    { src: starImages[3], width: 41, height: 21 },
  ]; /* prettier-ignore */ /* prettier-ignore-end */

  <template>
    <div data-test-star-legend class="text-dusty-black-300" ...attributes>
      <ul class="inline-flex items-start gap-4">
        {{#each this.starItems as |starImage index|}}
          {{#if (or @showNotPassed (gt index 0))}}
            <li class="relative flex items-center text-sm">
              <img
                src={{starImage.src}}
                width={{starImage.width}}
                height={{starImage.height}}
                alt={{t "tables.fluencySprints.starLegend.imageAlt" count=index}}
                class="print:invisible"
              />
              <span class="-z-1 text-transparent print:mr-2 print:inline-block print:font-bold print:text-black">
                {{t "tables.fluencySprints.starLegend.export" count=index}}:
              </span>
              {{t "tables.fluencySprints.starLegend.key" count=index}}
            </li>
          {{/if}}
        {{/each}}
      </ul>
    </div>
  </template>
}

export default StarLegend
